class StorageCache {
  constructor () {
    this.prefix = 'storageCache'
  }

  write (key, value, options = {}) {
    const data = JSON.stringify(this._getJson(value, options))
    localStorage.setItem(`${this.prefix}:${key}`, data)
  }

  read (key) {
    const json = localStorage.getItem(`${this.prefix}:${key}`)
    const data = this._parse(json)
    return data?.value
  }

  delete (key) {
    localStorage.removeItem(`${this.prefix}:${key}`)
  }

  clearExpiredAll () {
    for (let i = 0, l = localStorage.length; i < l; ++i) {
      const key = localStorage.key(i)
      const regexp = new RegExp(`^${this.prefix}:`)
      if (key.match(regexp)) {
        const json = localStorage.getItem(key)
        const data = this._parse(json)
        if (data.expire && new Date(data.expire) <= new Date()) {
          localStorage.removeItem(key)
        }
      }
    }
  }

  _parse (jsonData) {
    try {
      return JSON.parse(jsonData)
    } catch (_err) {
      return {}
    }
  }

  _getJson (value, options) {
    if (!options.expireDays) {
      return {value: value, expire: null}
    }

    const date = new Date()
    date.setDate(date.getDate() + options.expireDays)
    return {value: value, expire: date}
  }
}

export const storageCache = new StorageCache()
